import { usePlaygroundRole } from '@playground/features/auth/PlaygroundRoleContext'
import { RouterProvider } from '@tanstack/react-router'

import { router } from './router'

/** Feeds the signed-in role into the router context, for the route guards. */
const AppRouter = () => {
  const role = usePlaygroundRole()

  return <RouterProvider router={router} context={{ role }} />
}

export default AppRouter
